import { GET_PROJECTS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import {
	BRAND_PROJECTS_LIST_MODULE_ID, BRAND_PROJECTS_LIST_BANNER_HEADER_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import { project } from 'root/src/shared/descriptions/endpoints/recordTypes'
import { VIEW_PROJECT_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import { cardListType } from 'root/src/shared/constants/moduleTypes'
import { brandProjectsKey, activeKey } from 'root/src/shared/constants/keys'

export default {
	[BRAND_PROJECTS_LIST_MODULE_ID]: {
		moduleType: 'list',
		listType: cardListType,
		listPayload: {
			pageItemLength: 8,
			section: brandProjectsKey,
			subSection: activeKey,
		},
		recordType: project,
		endpointId: [GET_PROJECTS],
		listRouteId: VIEW_PROJECT_ROUTE_ID,
		goTopButton: true,
		sortFilterModule: BRAND_PROJECTS_LIST_BANNER_HEADER_MODULE_ID,
	},
}
